import { Button } from "../ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog"
import { BulkLeadResult } from "../../services/leadBulk"

interface BulkConfirmDialogProps {
  readonly open: boolean
  readonly title: string
  readonly description: string
  readonly confirmLabel: string
  readonly onCancel: () => void
  readonly onConfirm: () => void
  readonly pending: boolean
}

export function BulkConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  onCancel,
  onConfirm,
  pending,
}: BulkConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onCancel() }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel} disabled={pending}>
            Cancel
          </Button>
          <Button type="button" onClick={onConfirm} disabled={pending}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

interface BulkResultDialogProps {
  readonly open: boolean
  readonly succeededCount: number
  readonly failed: readonly BulkLeadResult[]
  readonly onClose: () => void
}

export function BulkResultDialog({ open, succeededCount, failed, onClose }: BulkResultDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose() }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Bulk action results</DialogTitle>
          <DialogDescription>
            {succeededCount} succeeded. {failed.length} failed.
          </DialogDescription>
        </DialogHeader>
        <ul className="max-h-60 space-y-2 overflow-y-auto text-sm text-slate-700">
          {failed.map((item) => (
            <li key={item.id}>
              {item.name || item.id}: {item.reason}
            </li>
          ))}
        </ul>
        <DialogFooter>
          <Button type="button" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
